async function CreateChopperDesignSelection (chopperid, componentid) {

    if (chopperid && componentid) {

            let response;

            let params = {
                "@ChopperDesignSelectionID": "",
                "@ChopperID": chopperid,
                "@ComponentID": componentid
              };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "133", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "TrimChoppers", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default CreateChopperDesignSelection;